// https://shopify.dev/docs/api/admin-graphql/unstable/queries/products

export const MULTI_PRODUCT_FILTER_CONSTANTS = {
    BASE_PRODUCT_OPTIONS: [
        { label: 'Title', value: 'title', type: 'string' },
        { label: 'Type', value: 'product_type', type: 'string' },
        { label: 'Category', value: 'category_id', type: 'string' },
        { label: 'Vendor', value: 'vendor', type: 'string' },
        { label: 'Vendor Style Number', value: 'vendor_style_number', type: 'string' },
        { label: 'Tag', value: 'tag', type: 'string' },
        { label: 'Price', value: 'price', type: 'number' },
        { label: 'Compare at Price', value: 'compareAtPrice', type: 'number' },
        { label: 'Inventory Stock', value: 'inventory_total', type: 'number' },
        { label: 'SKU', value: 'sku', type: 'string' },
    ],
};
